<template>
  <box-section class="result-content">
    <div class="inner-content">
      <header>
        <router-link to="/"><img class="back-arrow" src="../assets/back-arrow-dark.svg" alt=""></router-link>
        <h1>{{ title }}</h1>
      </header>
      <p class="lead-in">{{ answerSummary }}</p>
      <div class="result-page-section" v-for="section in content" :key="section.lead_in">
        <ul class="bullet-point-section" v-if="section.acf_fc_layout === 'bullet_point_section'">
          <li>
            <p>{{ section.lead_in }}</p>
            <p class="small">{{ section.description }}</p>
          </li>
        </ul>

        <div class="simple-content" v-html="section.content" v-if="section.acf_fc_layout === 'simple_content_area'"></div>

        <div class="side-by-side" v-if="section.acf_fc_layout === 'side_by_side'">
          <div class="column-1" v-html="section.column_1"></div>
          <div class="column-2" v-html="section.column_2"></div>
        </div>
      </div>
    </div>
    <aside class="bottom-link">
      <router-link to="/contact"><span>Get in touch with us - we can definitely help</span><img src="../assets/forward-arrow-dark.svg" alt=""></router-link>
    </aside>
  </box-section>
</template>

<script>
import BoxSection from './BoxSection'
import axios from 'axios'

export default {
  name: 'Services',

  components: { BoxSection },

  data () {
    return {
      answerSummary: '',
      title: '',
      content: [],
      metaInfo: {
        title: 'AuditLink'
      }
    }
  },

  metaInfo () {
    return {
      title: this.metaInfo.title
    }
  },

  mounted () {
    axios.get(process.env.ENDPOINT, {
      params: {
        slug: this.$route.params.slug
      }
    }).then(response => {
      this.title = response.data[0].title.rendered
      this.metaInfo.title = response.data[0].title.rendered
      this.answerSummary = response.data[0].acf.answer_summary
      this.content = response.data[0].acf.page_content
      document.dispatchEvent(new Event('content-loaded'))
    }).catch(error => {
      console.log(error)
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/QuestionResult.vue